import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { wikinaePalette } from '@mirinae/wikinae/modules/defines/styles';
import TextsBubbleStyle from '@mirinae/wikinae/components/texts/TextsBubble';
import { useAppVersionStore } from '@mirinae/stores/appVersion';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px 0;
    border: 1.5px solid ${wikinaePalette.desat[3]};
    border-radius: 5px;
    padding: 35px 20px 30px;
    text-align: center;
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px 0;
        padding: 0 10px;
    }
    strong {
        display: block;
        line-height: 100%;
        font-weight: 600;
        font-size: 14px;
    }
    p {
        line-height: 150%;
        font-weight: 500;
        font-size: 12px;
        color: ${wikinaePalette.desat[1]};
    }
    a {
        display: block;
        width: 188px;
        height: 53px;
        background: url('/assets/wikinae/banners/buyusacoffee.png') no-repeat 0 0/100% auto;
        font-size: 0;
        :hover {
            background-position: 0 100%;
        }
    }
`;

const MobileWrapper = styled.div`
    position: relative;
    margin-top: 30px;

    button, a {
        display: block;
        width: 100px;
        height: 100px;
        margin: auto;
        background: url('/assets/wikinae/banners/buyusacoffee-mini.png') no-repeat 0 0/100% auto;
        font-size: 0;
    }
`;
const TextBubble = styled.div`
    ${TextsBubbleStyle}
    top: -15px;
    left: 50%;
    transform: translate(-50%, -100%);
    width: calc(100vw - 40px);
    max-width: 330px;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    opacity: ${props => (props.theme === 'visible' ? 1 : 0)};
    pointer-events: ${props => (props.theme === 'visible' ? 'initial' : 'none')};
    transition: opacity 0.5s cubic-bezier(0.4, 0, 1, 1);

    :after {
        left: calc(50% - 4px);
    }
`;

const Banner = () => (
    <a href="https://www.buymeacoffee.com/wikinae" target="_blank" rel="noreferrer" title="☕ Buy us a coffee 🙂">
        ☕ Buy us a coffee 🙂
    </a>
);

const BuycoffeeBanner = ({ theme }) => {
    const [textBubble, setTextBubble] = useState(false);
    const isApp = useAppVersionStore(state => state.isApp);

    return theme === 'mobile' ? (
        <MobileWrapper>
            {isApp ? (
                <button type="button" onClick={() => setTextBubble(prev => !prev)}>Buy us a coffee</button>
            ) : (
                <Banner />
            )}
            <TextBubble theme={textBubble ? 'visible' : 'hidden'}>
                Thank you for your interest in supporting us! Unfortunately, this feature is currently only <b>available on our mobile website</b> (wikinae.mirinae.io). Could you please visit our mobile website to make a donation?
            </TextBubble>
        </MobileWrapper>
    ) : (
        <Wrapper>
            <div>
                <strong>Did you find this site helpful?</strong>
                <p>Feel free to show your support<br />by buying us a coffee.</p>
            </div>
            <Banner />
        </Wrapper>
    );
};

export default BuycoffeeBanner;